.activityDivider {
  font-size: 12px;
  text-transform: uppercase;
}
